import { apiClient } from './apiClient';

export type CollaboratorDependent = {
  id?: string;
  name: string;
  birthDate?: string | null;
  relationship: string;
  cpf: string;
  sortOrder?: number;
};

export type CollaboratorEducation = {
  id?: string;
  course: string;
  educationType: string;
  educationDegree?: string | null;
  institution: string;
  educationStatus: string;
  sortOrder?: number;
};

export type CollaboratorProfile = {
  appUserId: string;
  userName: string;
  cpf?: string | null;
  birthDate?: string | null;
  raceEthnicity?: string | null;
  gender?: string | null;
  sexualOrientation?: string | null;
  isPersonWithDisability: boolean;
  disabilityTypes: string[];
  employmentType?: string | null;
  jobPositionId?: string | null;
  jobPositionName?: string | null;
  jobLevel?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  state?: string | null;
  maritalStatus?: string | null;
  phone?: string | null;
  personalEmail?: string | null;
  cnpj?: string | null;
  dependents: CollaboratorDependent[];
  educations: CollaboratorEducation[];
};

export type CollaboratorProfileUpsertPayload = {
  cpf?: string;
  birthDate?: string | null;
  raceEthnicity?: string;
  gender?: string;
  sexualOrientation?: string;
  isPersonWithDisability?: boolean;
  disabilityTypes?: string[];
  employmentType?: string;
  jobPositionId?: string | null;
  jobLevel?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  maritalStatus?: string;
  phone?: string;
  personalEmail?: string;
  cnpj?: string;
  dependents: Array<{
    name: string;
    birthDate?: string | null;
    relationship?: string;
    cpf?: string;
  }>;
  educations: Array<{
    course: string;
    educationType: string;
    educationDegree?: string;
    institution?: string;
    educationStatus: string;
  }>;
};

export async function getCollaboratorProfile(userId: string): Promise<CollaboratorProfile> {
  const response = await apiClient.get<CollaboratorProfile>(`/v1/access-control/users/${userId}/profile`);
  return response.data;
}

export async function upsertCollaboratorProfile(
  userId: string,
  payload: CollaboratorProfileUpsertPayload,
): Promise<CollaboratorProfile> {
  const response = await apiClient.put<CollaboratorProfile>(
    `/v1/access-control/users/${userId}/profile`,
    payload,
  );
  return response.data;
}
